import React from "react";
import {
    BaseComponent, IBaseComponent,
    IBaseComponentProps,
} from "@reapptor-apps/reapptor-react-common";
import {ColumnDefinition, Grid} from "@reapptor-apps/reapptor-react-components";
import BookingBoat from "@/models/server/bout/BookingBoat";
import ListBookingBoatsResponse from "@/models/server/responses/ListBookingBoatsResponse";
import ListBookingBoatsRequest from "@/models/server/requests/ListBookingBoatsRequest";
import {BoatType} from "@/models/Enums";
import Localizer from "@/localization/Localizer";

import styles from "./BookingBoatsPanel.module.scss";

interface IBookingBoatsPanelProps extends IBaseComponentProps {
    bookingId: string;
}

interface IBookingBoatsPanelState {
}

export default class BookingBoatsPanel extends BaseComponent<IBookingBoatsPanelProps, IBookingBoatsPanelState> {
    
    state: IBookingBoatsPanelState = {
    };

    private readonly _gridRef: React.RefObject<Grid<BookingBoat>> = React.createRef();
    
    private readonly _columns: ColumnDefinition[] = [
        {
            header: "#",
            accessor: "#",
            minWidth: 40
        } as ColumnDefinition,
        {
            header: "Boat",
            accessor: nameof.full<BookingBoat>(o => o.boat!.model),
            minWidth: 200,
            settings: {
                infoAccessor: nameof.full<BookingBoat>(o => o.boat!.brand),
            },
        } as ColumnDefinition,
        {
            header: "Captain",
            accessor: nameof.full<BookingBoat>(o => o.boat!.captain!),
            minWidth: 200,
            settings: {
                infoAccessor: nameof.full<BookingBoat>(o => o.boat!.captain!.email),
            },
        } as ColumnDefinition,
        {
            header: "Area",
            accessor: nameof.full<BookingBoat>(o => o.boat!.area!),
            minWidth: 200,
            settings: {
                infoAccessor: nameof.full<BookingBoat>(o => o.boat!.boatType),
                infoFormat: nameof(BoatType),
            },
        } as ColumnDefinition,
        {
            header: "Distance",
            accessor: nameof.full<BookingBoat>(o => o.distance),
            minWidth: 100,
        } as ColumnDefinition,
        {
            header: "Price",
            accessor: nameof.full<BookingBoat>(o => o.price),
            minWidth: 100,
        } as ColumnDefinition,
    ];
    
    private async fetchAsync(sender: IBaseComponent): Promise<BookingBoat[]> {
        const request = new ListBookingBoatsRequest();
        request.bookingId = this.bookingId;
        
        const response: ListBookingBoatsResponse = await sender.postAsync("/api/booking/listBookingBoats", request);
        
        return response.items;
    }
    
    public get bookingId(): string {
        return this.props.bookingId;
    }
    
    public render(): React.ReactNode {
        return (
            <div id={this.id} className={this.css(styles.bookingBoatsPanel, "row", this.props.className)}>

                <h5>
                    <small>Available captains and boats</small>
                </h5>

                <Grid id="bookingStatus" responsive
                      ref={this._gridRef}
                      columns={this._columns}
                      noDataText={Localizer.genericNoData}
                      fetchData={(sender) => this.fetchAsync(sender)}
                />

            </div>
        )
    }
}